import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Inbox, Check, X, Crown } from "lucide-react";
import { Button } from "./ui/button";
import { toast } from "sonner";

export const UpgradeRequests = ({ ownerView = false, onChange }) => {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(null);

  const load = async () => {
    try {
      const res = await api.get("/billing/requests");
      setItems(res.data || []);
    } catch {}
  };

  useEffect(() => { load(); const t = setInterval(load, 12000); return () => clearInterval(t); }, []);

  const act = async (id, kind) => {
    setBusy(id);
    try {
      await api.post(`/billing/requests/${id}/${kind}`);
      toast.success(kind === "approve" ? "Member upgraded" : "Request rejected");
      await load();
      onChange?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Action failed");
    } finally {
      setBusy(null);
    }
  };

  if (items.length === 0) return null;

  const pending = items.filter((r) => r.status === "pending");
  const recent = items.slice(0, 8);

  return (
    <div className="border border-black/15 p-6" data-testid="upgrade-requests">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] font-bold text-[#E60000]">
        <Inbox className="w-3.5 h-3.5" /> Upgrade requests
        {pending.length > 0 && (
          <span className="ml-2 text-[10px] px-1.5 py-0.5 bg-[#E60000] text-white font-mono">{pending.length} pending</span>
        )}
      </div>

      <ul className="mt-4 space-y-2">
        {recent.map((r) => (
          <li key={r.id} className="flex items-center gap-3 border border-black/10 px-3 py-2.5" data-testid={`upgrade-request-${r.id}`}>
            <Crown className={`w-4 h-4 ${r.status === "pending" ? "text-[#E60000]" : "text-black/30"}`} />
            <div className="flex-1 min-w-0">
              <div className="text-sm font-bold tracking-tight">{r.user_name}</div>
              <div className="text-xs text-black/55">
                {r.user_email} · {r.tier} · {r.note || "no note"}
              </div>
            </div>
            <span className={`text-[10px] uppercase tracking-[0.2em] font-bold px-1.5 py-0.5 ${
              r.status === "approved" ? "bg-black text-white" :
              r.status === "rejected" ? "border border-black/20 text-black/40" :
              "bg-[#E60000]/10 text-[#E60000]"
            }`}>
              {r.status}
            </span>
            {ownerView && r.status === "pending" && (
              <div className="flex gap-1">
                <Button size="sm" onClick={() => act(r.id, "approve")} disabled={busy === r.id} className="rounded-sm bg-[#E60000] hover:bg-[#CC0000] text-white h-8 px-2.5" data-testid={`approve-${r.id}`}>
                  <Check className="w-3.5 h-3.5" />
                </Button>
                <Button size="sm" variant="outline" onClick={() => act(r.id, "reject")} disabled={busy === r.id} className="rounded-sm h-8 px-2.5" data-testid={`reject-${r.id}`}>
                  <X className="w-3.5 h-3.5" />
                </Button>
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
